import React from 'react';
import Redo from '../App/Redo'
import { Link } from 'react-router-dom';

import Banner from '../App/Banner';

import MoreThan10K from '../../assets/categories/MoreThan10K.png'
import Check from '../../assets/check.svg'
import Arrow from '../../assets/arrow.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function OSS() {
  return(
    <div>
      <Banner />
      <div id="FranceToFrance" className='paper'>

        <Link to='/FranceToUE'>
          <button className="return">
          <img src={GreyArrow} alt="fleche grise"/>
            Retour
          </button>
        </Link>

        <div className="breadcrumbs">
          <p><img src={Check} />Votre stock se situe en France</p>
          <p><img src={Check} />Vous vendez vers l'Union Européenne</p>
          <p><img src={Check} />Vous réalisez plus de 10 000 € en UE (hors France)</p>
        </div>

        <h4>La procédure :</h4>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Appliquez le taux de TVA du pays de destination</ul>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Déclarez votre TVA au guichet unique OSS</ul>

        <div className="when">
          <h5>Quand s’inscrire au guichet unique OSS ?</h5>
          <p>Dans le trimestre qui précède le dépassement du seuil (il est donc important d’anticiper l’évaluation de son CA à venir).</p>
        </div>

        <hr />

        <div className='categorie' >
          <h4>Si vous êtes client Dougs :</h4>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez la catégorie ci-dessous</ul>
          <img src={MoreThan10K} alt="Categorie superieur a 10K" style={{margin: "auto", paddingTop: "2em"}}/>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez le pays de destination</ul>
          <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />La TVA se calcule automatiquement</ul>
        </div>

        <div className="button">
          <Redo />
        </div>
        
      </div>
    </div>
  )
}

export default OSS